import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Modal } from '@material-ui/core'
import { ModalCard } from '../../components'
import { createDeviceEnd } from '../../state/SystemCache/actions'
import { getCreateDevice } from '../../state/SystemCache/selectors'
import { State, Category } from '../../types'
import CreateDeviceFormContainer from './CreateDeviceForm'

type Props = {
  category: Category
}

function CreateDeviceFormModal({ category }: Props) {
  const dispatch = useDispatch()
  const createDevice = useSelector<State, { editing: boolean }>(getCreateDevice)

  return (
    <Modal
      open={createDevice.editing}
      onClose={() => dispatch(createDeviceEnd())}
    >
      <ModalCard>
        <CreateDeviceFormContainer category={category} />
      </ModalCard>
    </Modal>
  )
}

export default CreateDeviceFormModal
